/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

export abstract class Application {
  public id: string;
  public label: string;
  public shortLabel: string;
  public description: string;
  public active: boolean;
  public iconMenu: string;
  public iconActive: string;
  public iconDisable: string;
  public logoActive: string;
  public logoDisable: string;
  public appType: {id: string, label: string}[] = [];
  public urlDoc: string;
  public urlApp: string;
  public route: string;

  public abstract getImage(): string;
  public abstract getTitle(): string;
}
